// src/state/register/customizer/types.ts
var SET_CUSTOMIZER_STATE = "SET_CUSTOMIZER_STATE";
var UPDATE_CUSTOMIZER_SECTOR = "UPDATE_CUSTOMIZER_SECTOR";
var SectorStatus = /* @__PURE__ */ ((SectorStatus2) => {
  SectorStatus2[SectorStatus2["INACTIVE"] = 0] = "INACTIVE";
  SectorStatus2[SectorStatus2["SELECTED"] = 1] = "SELECTED";
  return SectorStatus2;
})(SectorStatus || {});
var CustomizerTypes = /* @__PURE__ */ ((CustomizerTypes2) => {
  CustomizerTypes2["SUBCATEGORY"] = "subcategory";
  CustomizerTypes2["ITEM"] = "item";
  CustomizerTypes2["NONE"] = "none";
  return CustomizerTypes2;
})(CustomizerTypes || {});

export { CustomizerTypes, SET_CUSTOMIZER_STATE, SectorStatus, UPDATE_CUSTOMIZER_SECTOR };
